import { v1 as uuid } from "uuid";
import { getConfig } from "../config";
import makeRequest from "../services/apiService";
import { ENDPOINTS_CONST } from "./utils/api-constants";
import { COOKIES } from "./utils/enum";
import { getCookieValue } from "./utils/utils";
const CONFIG = getConfig();

export let isTvBasketEnabled = false;

export const getSubscriptionData = (headers) => {
const userAgent = getCookieValue(COOKIES.USER_AGENT);
const userId = userAgent ? JSON.parse(userAgent).user_id : null;
  const {method, endpoint} = ENDPOINTS_CONST.USER_DETAILS.GET_SUBSCRIPTIONS;
  makeRequest(method, endpoint(userId)).then(res => {
    globalVariable.classProfileCodes = res?.data?.classProfileCodes;
  }).catch(err => {
    console.log(err);
  });
}

export const irReadynessApi = (headers) => {
  return new Promise((resolve, reject) => {
    globalVariable.kyc = "equity";
    //globalVariable.stockList = [];
    globalVariable.existingSymbols = {};
    const userAgent = getCookieValue(COOKIES.USER_AGENT);
    const userId = userAgent ? JSON.parse(userAgent).user_id : null;
    const {method, endpoint} = ENDPOINTS_CONST.GET_READINESS_DATA;
    makeRequest(method, endpoint(userId)).then(res => {
      const { irStatus } = res.data.EQUITY.find((el) => el.subProduct === 'CASH') || {};
      const { irStatus: irStatusFO } = res.data.EQUITY.find((el) => el.subProduct === 'FO') || {};
      if(irStatusFO == "ACTIVE") {
        globalVariable.kyc = "full";
        globalVariable.isIrReady = true;
        resolve(globalVariable.isIrReady)
      } else if(irStatus == "ACTIVE") {
        globalVariable.kyc = "equity";
        globalVariable.isIrReady = true;
        resolve(globalVariable.isIrReady)
      } else {
        globalVariable.isIrReady = false;
        window.location.href = `${CONFIG.WEB_APP}/dashboard`
      }
    }).catch(err => {
      console.log(err);
      reject(err);
    });
  });
}

// export function checkAllowedUser() {
//   const userAgent = getCookieValue(COOKIES.USER_AGENT);
//   const userId = userAgent ? JSON.parse(userAgent).user_id : null;
//   const {method, endpoint} = ENDPOINTS_CONST.STOREFRONT_DATA;
//   return new Promise((resolve, reject) => {
//     makeRequest(method, endpoint(), {}, {user_id: userId}).then(res => {
//       const banner = [];
//       const { page } = res;
//       page.forEach((item) => {
//         if (item.id === CONFIG.PROMO_ID) {
//           banner.push(item);
//         }
//       });
//       const tvView = banner[0]?.views[0]?.items;
//       if(!tvView.length || tvView.isTvPanelEnabled) {
//         window.location.href = `${CONFIG.WEB_APP}/dashboard`
//       } else {
//         resolve(true)
//       }
//     }).catch(err => {
//       window.location.href = `${CONFIG.WEB_APP}/dashboard`
//       reject(err);
//     });
//   })
// 

export async function checkAllowedUser() {
  const userAgent = getCookieValue(COOKIES.USER_AGENT);
  const userId = userAgent ? JSON.parse(userAgent).user_id : null;
  const {method, endpoint} = ENDPOINTS_CONST.STOREFRONT_DATA;
  return new Promise((resolve, reject) => {
    const headers = {
      "x-request-id": uuid(),
      user_id: userId,
      'Content-Type': "application/json; charset=UTF-8",
      [COOKIES.SSO_TOKEN]: getCookieValue(COOKIES.SSO_TOKEN),
      [COOKIES.USER_AGENT]: getCookieValue(COOKIES.USER_AGENT),
    };
    makeRequest(method, endpoint(), {}, headers, true).then(res => {
      const banner = [];
      const { page } = res.data;
      page.forEach((item) => {
        if (item.id === CONFIG.PROMO_ID) {
          banner.push(item);
        }
      });
      const tvView = banner[0]?.views[0]?.items;
      if(tvView.length && tvView[0]?.isTvBasketEnabled === "true") {
        isTvBasketEnabled = true;
      } if(!tvView.length || tvView.isTvPanelEnabled) {
        window.location.href = `${CONFIG.WEB_APP}/dashboard`
      } else {
        resolve(true)
      }
    })
    .catch((error => {
      window.location.href = `${CONFIG.WEB_APP}/dashboard`;
      reject(error);
    }));
  });
}

export const getDowntimeConfig = async () => {
  const {method, endpoint} = ENDPOINTS_CONST.SLEEK_CARD;
  makeRequest(method, endpoint()).then(({ data: { sleekCard } = {} }) => {
    if (sleekCard && sleekCard.message) {
      const { message, cta_dl, cta_txt, icon } = sleekCard;
      const sleekCardWrapper = document.querySelector('.sleekCard');
      sleekCardWrapper.style.display = "flex";
      const sleekCardIcon = sleekCardWrapper.querySelector('.sleekCardImg');
      sleekCardIcon.src = icon;
      const sleekCardMsg = sleekCardWrapper.querySelector('.sleekCardMsg');
      sleekCardMsg.textContent = message;
      const sleekCardCta = sleekCardWrapper.querySelector('.sleekCardCta');
      sleekCardCta.textContent = cta_txt;
      sleekCardCta.onclick = function() { 
        window.location.href = cta_dl;
      };
      const sleekCardClose = sleekCardWrapper.querySelector('.sleekCardClose');
      sleekCardClose.onclick = function() { 
        sleekCardWrapper.style.display = "none";
      };
    }
  }).catch(err => {
    console.log("error fetching sleek card",err);
  });
};
